import ProductItems from 'components/ProductItems';
import './styles.scss';
import { Button } from 'components/buttons/Button/Button';

const ProductItemsBox = ({ title, data }) => (
    <div className="box product-box">
        <h3>{title}</h3>
        <ProductItems data={data} />
        <Button type="show-more">SHOW MORE</Button>
    </div>
);

export default ProductItemsBox;
